/** Un nœud de la hiérarchie botanique tel que l'API le renvoie (parents peuplés ou non). */
export interface HierarchyNode {
  name?: unknown;
  type?: string;
  parent?: HierarchyNode | null;
}

/**
 * Le nom de la famille d'une culture (« Apiacées »), jamais son nom latin :
 * on remonte la hiérarchie jusqu'au nœud FAMILY. Une culture chargée sans ses
 * parents (liste des graines, calendrier) n'a pas de famille connue : on
 * prend alors celle de la grille agronomique, sinon rien.
 */
export function cultivationFamilyName(
  hierarchy: HierarchyNode | null | undefined,
  agronomyFamily?: string | null,
): string {
  let node = hierarchy;
  // Quatre niveaux au plus (variété, espèce, genre, famille) : la boucle s'arrête même sur des données en cycle.
  for (let depth = 0; node && depth < 5; depth++) {
    if (node.type === 'FAMILY' && node.name) return String(node.name);
    node = node.parent;
  }
  return agronomyFamily ?? '';
}
